import { ReactElement } from 'react';
import './index.css';
import {
  SideMenuItem,
  SideMenu,
  SideMenuSection,
  SideMenuTitle,
  SideMenuSubTitle,
  SideMenuSelect,
} from './SideMenu';
import TopBar from './TopBar';
import { Section } from './types';

interface Props {
  children: ReactElement | Array<ReactElement | undefined> | undefined;
  sections?: Section[];
  hasPositiveProfit?: boolean;
}

export const Layout = (props: Props) => {
  const { children, hasPositiveProfit } = props;

  return (
    <div className="layout-container">
      <TopBar hasPositiveProfit={hasPositiveProfit} />
      <div className="layout-row">{children}</div>
    </div>
  );
};

const Content = ({ children }: Props) => {
  return <div className="content-container">{children}</div>;
};

Layout.Content = Content;
Layout.SideMenu = SideMenu;
Layout.SideMenuSection = SideMenuSection;
Layout.SideMenuTitle = SideMenuTitle;
Layout.SideMenuSubTitle = SideMenuSubTitle;
Layout.SideMenuItem = SideMenuItem;
Layout.SideMenuSelect = SideMenuSelect;

export default Layout;
